interface PhonePrefix {
  countryCode: string
  localeCode?: string
  phonePrefix: string
  sort: number
}

export const PhonePrefixes = [

  {
    countryCode: 'US',
    phonePrefix: '+1',
    sort: 1,
    localeCode: 'en-US',
  },
  {
    countryCode: 'CA',
    phonePrefix: '+1',
    sort: 1,
    localeCode: 'en-US',
  },
  {
    countryCode: 'US/CA',
    phonePrefix: '+1',
    sort: 1,
    localeCode: 'en-US',
  },
  {
    countryCode: 'RU',
    phonePrefix: '+7',
    sort: 7,
    localeCode: 'ru-RU',
  },
  {
    countryCode: 'GR',
    phonePrefix: '+30',
    sort: 30,
    localeCode: 'el-GR',
  },
  {
    countryCode: 'NL',
    phonePrefix: '+31',
    sort: 31,
    localeCode: 'nl-NL',
  },
  {
    countryCode: 'BE',
    phonePrefix: '+32',
    sort: 32,
    localeCode: 'nl-BE',
  },
  {
    countryCode: 'FR',
    phonePrefix: '+33',
    sort: 33,
    localeCode: 'fr-FR',
  },
  {
    countryCode: 'ES',
    phonePrefix: '+34',
    sort: 34,
    localeCode: 'es-ES',
  },
  {
    countryCode: 'HU',
    phonePrefix: '+36',
    sort: 36,
    localeCode: 'hu-HU',
  },
  {
    countryCode: 'IT',
    phonePrefix: '+39',
    sort: 39,
    localeCode: 'it-IT',
  },
  {
    countryCode: 'RO',
    phonePrefix: '+40',
    sort: 40,
    localeCode: 'ro-RO',
  },
  {
    countryCode: 'CH',
    phonePrefix: '+41',
    sort: 41,
    localeCode: 'de-CH',
  },
  {
    countryCode: 'AT',
    phonePrefix: '+43',
    sort: 43,
    localeCode: 'de-AT',
  },
  {
    countryCode: 'GB',
    phonePrefix: '+44',
    sort: 44,
    localeCode: 'en-GB',
  },
  {
    countryCode: 'DK',
    phonePrefix: '+45',
    sort: 45,
    localeCode: 'da-DK',
  },
  {
    countryCode: 'SE',
    phonePrefix: '+46',
    sort: 46,
    localeCode: 'sv-SE',
  },
  {
    countryCode: 'NO',
    phonePrefix: '+47',
    sort: 47,
    localeCode: 'nb-NO',
  },
  {
    countryCode: 'PL',
    phonePrefix: '+48',
    sort: 48,
    localeCode: 'pl-PL',
  },
  {
    countryCode: 'DE',
    phonePrefix: '+49',
    sort: 49,
    localeCode: 'de-DE',
  },
  {
    countryCode: 'MX',
    phonePrefix: '+52',
    sort: 52,
    localeCode: 'es-MX',
  },
  {
    countryCode: 'BR',
    phonePrefix: '+55',
    sort: 55,
    localeCode: 'pt-BR',
  },
  {
    countryCode: 'MY',
    phonePrefix: '+60',
    sort: 60,
    localeCode: 'ms-MY',
  },
  {
    countryCode: 'AU',
    phonePrefix: '+61',
    sort: 61,
    localeCode: 'en-AU',
  },
  {
    countryCode: 'ID',
    phonePrefix: '+62',
    sort: 62,
    localeCode: 'id-ID',
  },
  {
    countryCode: 'NZ',
    phonePrefix: '+64',
    sort: 64,
    localeCode: 'en-NZ',
  },
  {
    countryCode: 'SG',
    phonePrefix: '+65',
    sort: 65,
    localeCode: 'en-SG',
  },
  {
    countryCode: 'TH',
    phonePrefix: '+66',
    sort: 66,
    localeCode: 'th-TH',
  },
  {
    countryCode: 'JP',
    phonePrefix: '+81',
    sort: 81,
    localeCode: 'ja-JP',
  },
  {
    countryCode: 'KR',
    phonePrefix: '+82',
    sort: 82,
    localeCode: 'ko-KR',
  },
  {
    countryCode: 'CN',
    phonePrefix: '+86',
    sort: 86,
    localeCode: 'zh-CN',
  },
  {
    countryCode: 'TR',
    phonePrefix: '+90',
    sort: 90,
    localeCode: 'tr-TR',
  },
  {
    countryCode: 'PT',
    phonePrefix: '+351',
    sort: 351,
    localeCode: 'pt-PT',
  },
  {
    countryCode: 'LU',
    phonePrefix: '+352',
    sort: 352,
    localeCode: 'fr-LU',
  },
  {
    countryCode: 'IE',
    phonePrefix: '+353',
    sort: 353,
    localeCode: 'en-IE',
  },
  {
    countryCode: 'IS',
    phonePrefix: '+354',
    sort: 354,
    localeCode: 'is-IS',
  },
  {
    countryCode: 'CY',
    phonePrefix: '+357',
    sort: 357,
    localeCode: 'el-CY',
  },
  {
    countryCode: 'FI',
    phonePrefix: '+358',
    sort: 358,
    localeCode: 'fi-FI',
  },
  {
    countryCode: 'BG',
    phonePrefix: '+359',
    sort: 359,
    localeCode: 'bg-BG',
  },
  {
    countryCode: 'LT',
    phonePrefix: '+370',
    sort: 370,
    localeCode: 'lt-LT',
  },
  {
    countryCode: 'LV',
    phonePrefix: '+371',
    sort: 371,
    localeCode: 'lv-LV',
  },
  {
    countryCode: 'EE',
    phonePrefix: '+372',
    sort: 372,
    localeCode: 'et-EE',
  },
  {
    countryCode: 'HR',
    phonePrefix: '+385',
    sort: 385,
    localeCode: 'hr-HR',
  },
  {
    countryCode: 'SI',
    phonePrefix: '+386',
    sort: 386,
    localeCode: 'sl-SI',
  },
  {
    countryCode: 'CZ',
    phonePrefix: '+420',
    sort: 420,
    localeCode: 'cs-CZ',
  },
  {
    countryCode: 'SK',
    phonePrefix: '+421',
    sort: 421,
    localeCode: 'sk-SK',
  },
  {
    countryCode: 'HK',
    phonePrefix: '+852',
    sort: 852,
    localeCode: 'zh-HK',
  },
  {
    countryCode: 'IL',
    phonePrefix: '+972',
    sort: 972,
    localeCode: 'he-IL',
  },
]

export const PhonePrefixLocaleCodeMap: Record<string, PhonePrefix> = PhonePrefixes.reduce((acc, curr) => {
  acc[curr.phonePrefix] = curr
  return acc
}, {})
export const PhonePrefixCountryCodeMap: Record<string, PhonePrefix> = PhonePrefixes.reduce((acc, curr) => {
  acc[curr.countryCode] = curr
  return acc
}, {})

export const getPhonePrefixFromLocale = (locale: string) => {
  const prefix = PhonePrefixes.find(phonePrefix => phonePrefix.localeCode === locale)
  if (prefix) {
    return prefix.phonePrefix
  }

  if (PhonePrefixes.length !== 0) {
    return PhonePrefixes[0].phonePrefix
  }

  return ''
}
